import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Tab, Row, Col, Nav } from 'react-bootstrap';
import TickIcon from 'src/assets/images/common/white-tick.svg';
import Brands from './brands';
import AdAccount from './adAccount';
import Seller from './seller';
import Vendor from './vendor';
import SpinnerIcon from 'src/assets/icons/SpinnerIcon';
import DspAccount from './dspAccount';
import { todayIsActive } from 'src/utils/utils';
import { usePayloadContext } from 'src/contexts/PayloadContext';
import CheckBox from 'src/components/Form/checkbox';
import { Box } from '@mui/material';

export default function Tabs({ tabListData, closePopover, doFetchBrandsAccounts, listFilters, saveMasterFilters, updateSelectedItems, handleSubmit, updateInCludeSBSpends, includeSBSpends, setIncludeSBSpends, previewMasterFilters, showSellerVendorOverlay }) {


  const { payloadState } = usePayloadContext();
  const dateRangeConst = useRef(JSON.stringify(payloadState?.dateRange));
  const [selectedDateRange, setSelectedDateRange] = useState(payloadState?.dateRange);
  const [activeKey, setActiveKey] = useState('');
  const [isApplyEnabled, setIsApplyEnabled] = useState(true);
  const selectedProfile = JSON.parse(sessionStorage.getItem('selectedProfileId'));

  useEffect(() => {
      if(tabListData && tabListData.length > 0) {
        setActiveKey(tabListData[0].eventKey)
      }
  }, [JSON.stringify(tabListData)])

  const updateAdAccountSelection = useCallback((event, level, adAccount, isRadio) => {
    let updatedSelectedItems = saveMasterFilters.map(item => item.level === level ? { ...item } : item);
    let adAccountItem = updatedSelectedItems.find(item => item.level === level);
    
    if (!adAccountItem) {
      adAccountItem = { level: level, keywords: [] };
      updatedSelectedItems.push(adAccountItem);
    }

    if (event.target.checked) {
      if (adAccount === 'selectAll') {
        adAccountItem.keywords = listFilters?.ams.map(account => account.value);
      } else {
        adAccountItem.keywords = isRadio ? [adAccount.value] : [...new Set([...(adAccountItem.keywords || []), adAccount.value])];
      }
    } else {
      if (adAccount === 'selectAll') {
        adAccountItem.keywords = [];
      } else {
        adAccountItem.keywords =  isRadio ? [] : (adAccountItem.keywords || []).filter(keyword => keyword !== adAccount.value);
      }
    }

    updateSelectedItems(updatedSelectedItems);
  }, [saveMasterFilters, updateSelectedItems, listFilters]);

  useEffect(() => {
    if (activeKey === 'ad_account') {
      const adAccountItem = saveMasterFilters.find(item => item.level === 'ams');
      setIsApplyEnabled(adAccountItem && adAccountItem.keywords.length > 0);
    } else {
      // For all other tabs, always enable the Apply button
      setIsApplyEnabled(true);
    }
  }, [activeKey, saveMasterFilters]);

  useEffect(() => {
    if (dateRangeConst.current != JSON.stringify(payloadState?.dateRange)) {
      setSelectedDateRange(payloadState?.dateRange);
      dateRangeConst.current = JSON.stringify(payloadState?.dateRange);
    }
  }, [payloadState?.dateRange]);

  const isTargeting360 = window.location.pathname.includes('/amazon/targeting')
  const isFlipkart = window.location.pathname.includes('/flipkart')

  const getSelectedAndPreviewCount = useCallback((tab) => {
    const saved = saveMasterFilters.find(item => item.level === tab)?.keywords?.length || 0;
    const preview = listFilters?.[tab]?.length || 0;
    if (tab == 'dsp') {
      return
    }
    return `(${saved}/${preview})`;
  }, [saveMasterFilters, listFilters])

  return (
    <React.Fragment key={doFetchBrandsAccounts.loading + listFilters?.length}>
      <Tab.Container id="left-tabs-example" activeKey={activeKey} onSelect={(k) => setActiveKey(k)}>
        {doFetchBrandsAccounts.loading ? <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            height: '100%',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: '1'
          }}
        >
          <SpinnerIcon width={30} height={30} style={{ color: '#1877f2' }} />
        </div> : null}
        <Box px={'15px'} py={'20px'} className={`mx-0 ${doFetchBrandsAccounts.loading ? 'disabled' : ''}`}>
          {showSellerVendorOverlay ? <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.85)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1,
              borderRadius: '8px'
            }}
          >
            <Box className='bg-white p-2 box-shadow rounded-8 d-flex align-items-center justify-content-center'>
              <span className="f-10 f-w-600 m-0" style={{ color: 'red' }}>
                {`At least one seller or vendor is required.`}
              </span>
            </Box>
          </Box> : null}
          <Box pl={'2px'} gap={'10px'} className="d-flex flex-row" style={{ ...(tabListData.length == 1 ? { display: 'none' } : {}) }}>
            <Nav variant="pills" className="flex-row">
              {tabListData.filter((tabItem) => ((todayIsActive(selectedDateRange) && tabItem.eventKey !== 'brands') || (!todayIsActive(selectedDateRange)))).map((tab) => {
                if(tab?.listParam === 'dsp' && selectedProfile?.accessLevel?.toLowerCase() !== 'agency') {
                  return (
                <div className='d-flex justify-content-between align-items-center'>
                  <div eventKey={tab.eventKey} className="text-dark inter f-w-500 f-13" >
                    {tab.title}&nbsp;
                  </div>
                  <div
                    onClick={() => window.open("/amazon-dsp-request/create", "_blank")}
                    className="text-blue cursor-pointer inter f-w-500 f-13 ml-200"
                  >
                    + Add Account 
                  </div>{" "}
                </div>
              )
                }else{
                  return (
                <Nav.Item key={tab.eventKey}>
                  <Nav.Link eventKey={tab.eventKey} active={tab.eventKey === activeKey} className="text-dark" >
                    {tab.eventKey === activeKey && <img src={TickIcon} alt="selected-tab" className="wid-15" />}
                    {tab.title}&nbsp;
                    {getSelectedAndPreviewCount(tab.listParam)}
                  </Nav.Link>
                </Nav.Item>
              )
                }
              })}
            </Nav>
          </Box>
          <Box>
            <Tab.Content style={{padding: '0px'}}>
              <Tab.Pane eventKey="brands">
                <Brands level="brands" list={listFilters?.brands} selectedItems={saveMasterFilters} updateSelectedItems={updateSelectedItems} />
              </Tab.Pane>
              <Tab.Pane eventKey="ad_account">
                <AdAccount level="ams" isRadio={tabListData?.some((item) => item?.eventKey === 'ad_account' && item?.fieldType === 'radio')} list={listFilters?.ams} selectedItems={saveMasterFilters} updateSelectedItems={updateAdAccountSelection} />
              </Tab.Pane>
              {/* do not show */}
              <Tab.Pane eventKey="dsp_account">
                <DspAccount level="dsp" list={listFilters?.dsp} selectedItems={saveMasterFilters} updateSelectedItems={updateSelectedItems} />
              </Tab.Pane>
              <Tab.Pane eventKey="seller">
                <Seller level="seller" isRadio={tabListData?.some((item) => item?.eventKey === 'seller' && item?.fieldType === 'radio')} list={listFilters?.seller} selectedItems={saveMasterFilters} updateSelectedItems={updateSelectedItems}  />
              </Tab.Pane>
              <Tab.Pane eventKey="vendor">
                <Vendor level="vendor" list={listFilters?.vendor} selectedItems={saveMasterFilters} updateSelectedItems={updateSelectedItems} />
              </Tab.Pane>
            </Tab.Content>
          </Box>
          <Box className='d-flex align-items-center justify-content-between' pt={'15px'}>
            <Box pl={'2px'}>
              {tabListData?.length === 1 && tabListData.some((val) => val.eventKey === 'dsp_account') || isFlipkart ? null :
                <CheckBox
                  label="Include SB spends of the products"
                  classes={`f-101828 f-12 f-w-500  ${isTargeting360 ? 'disabled' : ''}`}
                  checked={isTargeting360 ? true : includeSBSpends}
                  action={isTargeting360 ? () => { } : updateInCludeSBSpends}
                />
              }
            </Box>
            <Box className="d-flex align-items-center justify-content-end bg-white">
              <p className="cls-btn cursor-pointer rounded-4 f-10 py-2 px-3 f-w-600 f-202226" onClick={closePopover}>
                Cancel
              </p>
              <p className={`rounded-4 f-10 py-2 px-3 f-w-600 cursor-pointer text-white mt-0 ml-2 ${isApplyEnabled ? 'bg-blue' : ' bg-blue opacity-50'}`} onClick={isApplyEnabled ? handleSubmit : null}>Apply</p>
            </Box>
          </Box>
        </Box>
      </Tab.Container>
    </React.Fragment>
  );
}